// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerRoutes.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function () {
  var React = require('react');
  var Route = require('react-router').Route;
  var routeUtils = require('share/utils/Izenda.RouteUtils');

  var ReportDesignerRoot = require('modules/ReportDesigner/Izenda.ReportDesignerRoot');

  var onChangeReportDesigner = function (prevState, nextState) {
    nextState.location.isNewReport = true;
  };

  var ReportDesignerRoutes = function () {
    var ROUTE = routeUtils.getConfigRoute('ReportDesigner');
    var EDIT_ROUTE = routeUtils.getConfigRoute('ReportDesigner', 'ReportDesignerDetail');

    return  (
      <Route
        path={ROUTE.path}
        component={ReportDesignerRoot.Container}
        onChange={onChangeReportDesigner}>
        <Route
          name={EDIT_ROUTE.name}
          path={EDIT_ROUTE.path}
          component={ReportDesignerRoot.Container} />
      </Route>
    );
  };

  module.exports = ReportDesignerRoutes;
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Izenda.ReportDesignerRoutes.js